export default "__VITE_ASSET__YMZBXiEK__"